import { PageRoute } from "../../routes/PageRoute";
import { fakeRoute, sampleRoute, homeRoute, chiSiamoRoute, serviziRoute, loStudioRoute, contattiRoute } from "../../routes/Routes";
import { Language } from "../Languages/Languages";

export interface MenuContent {
  Type: "Route" | "Language" | "Link";
  Name?: string;
  Route?: PageRoute;
  Languages?: Language[];
  Link?: string;

  SubMenu?: MenuContent[];
}

export const newsSubMenuItems: MenuContent[] = [
  { Type: "Route", Route: fakeRoute },
  // { Type: "Route", Route: bioRoute },
  // { Type: "Route", Route: contattiRoute },
  // { Type: "Route", Route: serviziRoute },
];

export const sampleSubMenuItems: MenuContent[] = [
  { Type: "Route", Route: sampleRoute },
  // { Type: "Route", Route: bioRoute },
  // { Type: "Route", Route: contattiRoute },
  // { Type: "Route", Route: serviziRoute },
];

const languages: Language[] = [
  { Name: "Italiano", Value: "it" },
  { Name: "English", Value: "en" },
  { Name: "Espanol", Value: "es" },
];

export const menuItems: MenuContent[] = [
  { Type: "Route", Route: homeRoute },
  { Type: "Route", Route: chiSiamoRoute },
  // { Type: "Route", Route: bioRoute },
  { Type: "Route", Route: serviziRoute },
  { Type: "Route", Route: loStudioRoute },
  // { Type: "Route", SubMenu: sampleSubMenuItems, Name: "Sample" },
  // { Type: "Route", SubMenu: newsSubMenuItems, Name: "News" },
  { Type: "Route", Route: contattiRoute },
  { Type: "Language", Languages: languages, Name: "Language" },
];
